import { CircularProgress, Grid } from '@material-ui/core'

const LoadingScreen = ({ text = 'Chargement...' }) => {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.7)',
    color: 'black',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '26px',
  }

  return (
    <Grid
      container
      style={overlayStyle}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      {text}
      <CircularProgress style={{ marginTop: '25px' }} />
    </Grid>
  )
}

export default LoadingScreen
